/** Panel markası — ileride tenant başına API ile değiştirilebilir. */
export const SITE_NAME = 'Site Analiz';
export const SITE_TAGLINE = 'Yönetim Paneli';
export const SITE_INITIALS = 'SA';
